

var errors ={
    REGISTRATION_FAILED: 501,
    EMAIL_ALREADY_REGISTRED: 502,
    PHONE_NUMBER_ALREADY_REGISTRED: 503,
    USER_ALREADY_REGISTER_WITH_SOCIAL: 505,
    USER_NOT_REGISTER_WITH_SOCIAL: 506,
    LOGIN_FAILED: 511,
    NOT_A_REGISTERED: 512,
    INVALID_PASSWORD: 513,
    UPDATE_FAILED: 521,
    DEVICE_TOKEN_UPDATE_FAILED: 522,
    LOGOUT_FAILED: 523,
    INVALID_REFERRAL_CODE: 531,
    ALREADY_APPLY_REFERRAL_CODE: 532,
    REFERRAL_PROCESS_FAILED: 533,
    USER_DATA_NOT_FOUND: 534,
    GET_ORDER_CART_INVOICE_FAILED: 535,
    WALLET_AMOUNT_ADD_FAILED: 536,
    CHANGE_WALLET_STATUS_FAILED: 537,
    CHECK_PAYMENT_FAILED: 538,
    ORDER_HISTORY_NOT_FOUND: 539,
    ORDER_DETAIL_NOT_FOUND: 540,
    INVALID_REFERRAL: 541,
    OTP_VERIFICATION_FAILED: 542,
    EMAIL_AND_PHONE_ALREADY_REGISTERED: 543,
    PROMO_APPLY_FAILED: 544,
    INVALID_PROMO_CODE: 545,
    INVALID_OR_EXPIRED_PROMO_CODE: 546,
    INVALID_REFERRAL_FOR_YOUR_COUNTRY: 547,
    INVOICE_NOT_FOUND: 548,
    YOUR_ORDER_PAYMENT_PENDING: 549,
    REFERRAL_CODE_OUT_OF_USES_LIMIT_IN_YOUR_COUNTRY: 550,
    PROMO_CODE_ALREADY_USED: 551,
    PROMO_CODE_NOT_FOR_CITY: 552,
    YOUR_DELIVERY_CHARGE_FREE_YOU_CAN_NOT_APPLY_PROMO: 553,

    ADD_FAVOURITE_STORE_FAILED: 554,
    DELETE_FAVOURITE_STORE_FAILED: 555,
    FAVOURITE_STORE_LIST_NOT_FOUND: 556,

    YOUR_ORDER_PRICE_LESS_THEN_STORE_MIN_ORDER_PRICE: 557,
    YOUR_WALLET_AMOUNT_NEGATIVE: 569,

    STORE_REVIEW_LIST_NOT_FOUND: 807,
    STORE_REVIEW_DATA_NOT_FOUND: 808,
    STORE_REVIEW_LIKE_FAILED: 809,

    DELIVERY_SERVICE_NOT_AVAILABLE_IN_YOUR_CITY: 558,
    PROMO_USED_OUT_OF_LIMIT: 559,
    PROMO_AMOUNT_LESS_THEN_MINIMUM_AMOUNT_LIMIT: 560,
    STORE_LIST_NOT_FOUND: 561,
    INVALID_SERVER_TOKEN: 999,
    DETAIL_NOT_FOUND: 1000,
    TOKEN_EXPIRED: 2000,
    SET_PASSWORD_FAILED: 2001,
    INSUFFICIENT_BALANCE: 2002,
    SOMETHING_WENT_WRONG: 2003,
    PLEASE_CHECK_WITH_AMOLE: 3000,
   
   
    PROVIDER_VEHICLE_ADD_FAILED: 434,
    PROVIDER_VEHICLE_UPDATE_FAILED: 435,
    PROVIDER_VEHICLE_LIST_NOT_FOUND: 436,
    DOCUMENT_UPLOAD_FIRST: 437,
    ADD_VEHICLE_FIRST: 438,
    VEHICLE_TYPE_NOT_ASSIGNED_OR_NOT_APPROVED: 439,
     ORDER_FAILED: 651,
    ORDER_NOT_FOUND: 652,
    SET_ORDER_STATUS_FAILED: 653,
    REQUEST_FAILED: 654,
    CHANGE_ORDER_STATUS_FAILED: 655,
    ORDER_CANCEL_FAILED: 656,
    ORDER_CANCEL_OR_REJECT_BY_PROVIDER_FAILED: 657,
    ORDER_CANCEL_OR_REJECT_BY_STORE_FAILED: 658,
    ORDER_COMPLETE_FAILED: 659,
    ORDER_UNIQUE_CODE_INVALID: 660,
    ORDER_NOT_READY: 661,
    ORDER_ALREADY_CANCELLED: 662,
    ORDER_ALREADY_ACCPETED_BY_ANOTHER_PROVIDER : 663,
    CART_ADD_FAILED: 961,
    CART_NOT_FOUND: 962,
    CART_UPDATE_FAILED: 963,
    CART_DELETE_FAILED: 964,
    CHANGE_DELIVERY_ADDRESS_FAILED: 965
}


export const check_error_code = function (code) {
    // console.log(user_errors)
    var message = getObjKey(errors, code)
    if (!message){
        return `Error occured,${code}`
    }
    else return message.replace(/_/gi,' ')
    // if (code == 512){
    //     return 'Not registered'
    // }
    // else if(code == 513){
    //     return 'Invalid Password'
    // }
    // else if(code == 511){
    //     return 'Login Failed'
    // }
    // else if(code == 513){
    //     return 'Invalid Password'
    // }
}
function getObjKey(obj, value) {
    return Object.keys(obj).find(key => obj[key] === value);
  }